import { render, staticRenderFns } from "./eventRegistration.vue?vue&type=template&id=fefbbffe&scoped=true&"
import script from "./eventRegistration.vue?vue&type=script&lang=js&"
export * from "./eventRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefbbffe",
  null
  
)

export default component.exports